import { gql } from '@urql/core';
import {
    HighSchoolMyProfileDocument,
    HighSchoolMyProfileQuery,
    HighSchoolMyProfileQueryVariables,
} from 'generated/spin-graphql';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { useAuthenticatedQuery } from '../../../client/hooks';

import { GenericInLayoutPageLoading } from '../../common/GenericFullPageLoading';
import { HighSchoolProfile } from '../../highschool/profile-page/HighSchoolProfile';

gql`
    query HighSchoolMyProfile($id: uuid!) {
        espin_high_school_by_pk(id: $id) {
            ...HighSchoolProfile
        }
    }
`;

export function HighSchoolMyProfile({ user }: { user: AppStateUser }) {
    const { isReady, data } = useAuthenticatedQuery<HighSchoolMyProfileQuery, HighSchoolMyProfileQueryVariables>(
        {
            query: HighSchoolMyProfileDocument,
            variables: useMemo(() => ({ id: user?.high_school_profile?.high_school?.id }), [user]),
            pause: !!!user?.high_school_profile?.high_school?.id,
        },
        ['espin_high_school'],
    );

    if (!isReady) {
        return <GenericInLayoutPageLoading />;
    }
    return (
        <div className="high-school-my-profile-container">
            <div className="profile-container">
                <HighSchoolProfile highSchool={data.espin_high_school_by_pk} />
            </div>
            <Link href="/dashboard/my-profile/edit">
                <a className="button large-button blue-button">Edit Profile</a>
            </Link>
        </div>
    );
}
